import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { textareaVariants, type TextareaProps } from './variants';

/**
 * Multi-line text input with design-system variants — the textarea sibling of
 * {@link Input}.
 *
 * @example
 * ```tsx
 * <Textarea placeholder="Share your take…" maxLength={1000} />
 * ```
 */
const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, textareaSize, ...props }, ref) => (
  <textarea ref={ref} className={cn(textareaVariants({ textareaSize }), className)} {...props} />
));
Textarea.displayName = 'Textarea';

export { Textarea };
